import button_group_vue_vue_type_script_setup_true_lang_default from "./button-group.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/button/src/button-group.vue
var button_group_default = button_group_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { button_group_default as default };
//# sourceMappingURL=button-group2.mjs.map